import { useState, useEffect } from 'react';

export const useFileCarousel = () => {
  const [showCarousel, setShowCarousel] = useState(false);
  const [carouselFiles, setCarouselFiles] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openCarousel = (files, startIndex = 0) => {
    setCarouselFiles(files || []);
    setCurrentIndex(startIndex);
    setShowCarousel(true);
  };

  const closeCarousel = () => {
    setShowCarousel(false);
    setCarouselFiles([]);
    setCurrentIndex(0);
  };

  const nextFile = () => {
    if (carouselFiles.length === 0) return;
    setCurrentIndex((prev) => (prev + 1) % carouselFiles.length);
  };

  const prevFile = () => {
    if (carouselFiles.length === 0) return;
    setCurrentIndex((prev) => (prev - 1 + carouselFiles.length) % carouselFiles.length);
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (!showCarousel) return;
      if (e.key === 'ArrowLeft') prevFile();
      if (e.key === 'ArrowRight') nextFile();
      if (e.key === 'Escape') closeCarousel();
    };
    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [showCarousel, carouselFiles.length, prevFile, nextFile, closeCarousel]);

  return {
    showCarousel,
    carouselFiles,
    currentIndex,
    setCurrentIndex,
    openCarousel,
    closeCarousel,
    nextFile,
    prevFile
  };
};